import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { Skeleton } from "@mui/material";
import * as React from "react";

import styles from "./TopicTreeSkeleton.module.css";

interface TopicTreeSkeletonProps {
  /**
   * The estimated number of topics to render.
   * Ideally this should match the actual number of topics in the file
   */
  estimatedTopicCount: number;
}

// We randomize the widths to give the illusion of loading real data
// Values picked by trial and error to look good
const titleWidths = ["80%", "85%", "90%"];
const subtitleWidths = ["50%", "60%", "70%"];

export function TopicTreeSkeleton(props: TopicTreeSkeletonProps) {
  const { estimatedTopicCount } = props;

  const topicTree = React.useMemo(() => {
    return Array.from({ length: estimatedTopicCount });
  }, [estimatedTopicCount]);

  return (
    <div className={styles.topicRoot}>
      {topicTree.map((_, i) => (
        <TopicSkeleton key={i} />
      ))}
    </div>
  );
}

function TopicSkeleton() {
  const titleWidth = React.useMemo(() => {
    return titleWidths[Math.floor(Math.random() * titleWidths.length)];
  }, []);

  const subtitleWidth = React.useMemo(() => {
    return subtitleWidths[Math.floor(Math.random() * subtitleWidths.length)];
  }, []);

  return (
    <div className={styles.topic}>
      <KeyboardArrowRightIcon className={styles.expandIcon} />
      <div className={styles.textContainer}>
        <Skeleton
          animation="wave"
          className={styles.title}
          variant="text"
          width={titleWidth}
        />
        <Skeleton
          animation="wave"
          className={styles.subtitle}
          variant="text"
          width={subtitleWidth}
        />
      </div>
    </div>
  );
}
